/* Bayou Beignet: sticky header shrink and the hero's falling batch.
   Motion uses transforms only and resolves immediately when reduced
   motion is requested. */
(function () {
  var ticking = false;
  var fallRoot = document.querySelector('[data-bb-hero-fall]');
  var fallPieces = fallRoot ? Array.prototype.slice.call(fallRoot.querySelectorAll('[data-fall-piece]')) : [];
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function easeOutCubic(value) {
    return 1 - Math.pow(1 - value, 3);
  }

  function updateFallingBatch() {
    if (!fallRoot || !fallPieces.length) return;

    var rect = fallRoot.getBoundingClientRect();
    var pageScroll = Math.max(0, window.scrollY || document.documentElement.scrollTop || 0);
    var fallDistance = clamp(rect.height * 0.9, 480, 640);
    var rawProgress = reducedMotion.matches ? 1 : clamp(pageScroll / fallDistance, 0, 1);

    fallPieces.forEach(function (piece) {
      var delay = parseFloat(piece.dataset.delay || '0');
      var localProgress = clamp((rawProgress - delay) / Math.max(0.01, 1 - delay), 0, 1);
      var eased = easeOutCubic(localProgress);
      // Land at an absolute point in the bowl, measured from wherever the
      // piece actually starts (its CSS position, which differs by viewport).
      // This keeps every beignet converging into the bowl no matter where
      // around the frame it began.
      var targetX = parseFloat(piece.dataset.landTargetX || '0') * rect.width;
      var targetY = parseFloat(piece.dataset.landTargetY || '0') * rect.height;
      var deltaX = (targetX - piece.offsetLeft) * eased;
      var deltaY = (targetY - piece.offsetTop) * eased;
      var startRotate = parseFloat(piece.dataset.startRotate || '0');
      var landingRotate = parseFloat(piece.dataset.landRotate || '0');
      var rotation = startRotate + ((landingRotate - startRotate) * eased);
      var settlingLift = reducedMotion.matches ? 0 : Math.sin(localProgress * Math.PI) * -10;

      piece.style.transform = 'translate3d(' + deltaX + 'px,' + (deltaY + settlingLift) + 'px,0) rotate(' + rotation + 'deg)';
    });

  }

  function update() {
    document.body.classList.toggle('bb-shrunk', (window.scrollY || 0) > 200);
    updateFallingBatch();
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', onScroll);
  update();
})();

/* Powdered sugar that falls off the beignet buttons on hover, focus,
   and click. Particles are tiny spans removed when their fall finishes;
   the whole thing is skipped when the visitor prefers reduced motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SELECTOR = '.bb-btn, .product-form__submit';

  function fleck(btn) {
    var span = document.createElement('span');
    span.className = 'bb-sugar-fleck';
    var size = 2.5 + Math.random() * 3.5;
    span.style.left = (8 + Math.random() * 84) + '%';
    span.style.top = (32 + Math.random() * 46) + '%';
    span.style.width = size.toFixed(1) + 'px';
    span.style.height = size.toFixed(1) + 'px';
    span.style.setProperty('--drift', (Math.random() * 26 - 13).toFixed(1) + 'px');
    span.style.setProperty('--fall', (30 + Math.random() * 30).toFixed(1) + 'px');
    span.style.animationDuration = (0.65 + Math.random() * 0.5).toFixed(2) + 's';
    span.addEventListener('animationend', function () { span.remove(); });
    btn.appendChild(span);
  }

  function burst(btn, count) {
    for (var i = 0; i < count; i++) fleck(btn);
  }

  function attach(btn) {
    if (btn.dataset.bbSugar) return;
    btn.dataset.bbSugar = '1';
    var timer = null;

    btn.addEventListener('mouseenter', function () {
      if (reduce.matches || timer) return;
      burst(btn, 3);
      timer = setInterval(function () { burst(btn, 2); }, 220);
    });
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    btn.addEventListener('mouseleave', stop);
    btn.addEventListener('blur', stop);
    btn.addEventListener('focus', function () {
      if (!reduce.matches) burst(btn, 4);
    });
    btn.addEventListener('click', function () {
      if (!reduce.matches) burst(btn, 16);
    });
  }

  function init() {
    var btns = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < btns.length; i++) attach(btns[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
